import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { ChiroLandingPage } from './components/ChiroLandingPage';
import { QuizForm } from './components/QuizForm';
import { ResultsPage } from './components/ResultsPage';
import { NonQualifiedResultsPage } from './components/NonQualifiedResultsPage';
import { ConfirmationPage } from './components/ConfirmationPage';
import Footer from './components/Footer';
import { useUTMCapture } from './hooks/useUTMTracking';
// ScrollToTop component to handle page navigation scrolling
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AppContent() {
  // Capture UTM parameters on app load (catches params on any initial page)
  useUTMCapture();
  const location = useLocation();
  useEffect(() => {
    // Meta Pixel Code
    !function (f: any, b: any, e: any, v: any, n: any, t: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '1497745688153046');
    (window as any).fbq('track', 'PageView');
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1497745688153046&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, [location.pathname]);
  return <>
      <ScrollToTop data-id="element-0" />
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/chiro" element={<ChiroLandingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/calculator" element={<QuizForm data-id="element-7" />} data-id="element-6" />
        <Route path="/results" element={<ResultsPage data-id="element-9" />} data-id="element-8" />
        <Route path="/results/preview" element={<ResultsPage preview={true} data-id="element-11" />} data-id="element-10" />
        <Route path="/nonqualifiedresults" element={<NonQualifiedResultsPage data-id="element-13" />} data-id="element-12" />
        <Route path="/confirmation" element={<ConfirmationPage data-id="element-15" />} data-id="element-14" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-17" />} data-id="element-16" />
      </Routes>
      <Footer data-id="element-18" />
    </>;
}
export function App() {
  return <BrowserRouter data-id="element-19">
      <AppContent data-id="element-20" />
    </BrowserRouter>;
}